export interface Paging {
  currentPage: number;
  perPage: number;
  totalPage: number;
  total: number;
}

export const toPaging = (data: any) => {
  return {
    currentPage: data.current_page,
    perPage: data.per_page,
    totalPage: data.total_page,
    total: data.total,
  };
};
